import { render, staticRenderFns } from "./classTeacher.vue?vue&type=template&id=ca1d6cbc&scoped=true"
import script from "./classTeacher.vue?vue&type=script&lang=js"
export * from "./classTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d6cbc",
  null
  
)

export default component.exports